class Timer {
  constructor(callback, delay, timeListen) {
    this.callback = callback;
    this.remainingTime = delay;
    this.startTime = 0;
    this.timerId = 0;
    this.timeListen = timeListen;
  }

  pause() {
    clearTimeout(this.timerId);
    this.remainingTime -= Date.now() - this.startTime;
    this.timeListen.pause && this.timeListen.pause();
  }

  resume() {
    this.startTime = Date.now();
    clearTimeout(this.timerId);
    this.timerId = setTimeout(this.callback, this.remainingTime);
    this.timeListen.resume && this.timeListen.resume();
  }

  start() {
    this.timerId = setTimeout(this.callback, this.remainingTime);
    this.startTime = Date.now();
    this.timeListen.start && this.timeListen.start();
  }
}

export default Timer;
